// Minimal progressive JS scoped to Anzeigenmarkt pages
(function(){
  'use strict';

  // CSRF Token helper - read from meta tag
  function getCsrfToken() {
    var meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.getAttribute('content') : '';
  }

  // Highlight active nav link
  function markActiveNav(){
    try {
      var here = location.pathname.replace(/\/$/, '');
      var links = document.querySelectorAll('header nav a');
      links.forEach(function(a){
        var href = a.getAttribute('href') || '';
        var path = href.replace(/\/$/, '');
        if(path && here.indexOf(path) === 0){ a.classList.add('active'); }
      });
    } catch(e) { /* no-op */ }
  }

  // Small helper: fetch JSON with timeout (to reuse later for filters/chat)
  function fetchJSON(url, opts){
    opts = opts || {};
    var ctrl = new AbortController();
    var t = setTimeout(function(){ ctrl.abort(); }, opts.timeout || 10000);
    return fetch(url, {headers:{'Accept':'application/json'}, signal: ctrl.signal})
      .then(function(r){ clearTimeout(t); return r.ok ? r.json() : Promise.reject(new Error('HTTP '+r.status)); });
  }

  // Expose minimal API under window.AM
  window.AM = window.AM || { fetchJSON: fetchJSON };
  
  // Favorites toggle - handles all favorite button variants
  function toggleFav(btn, id){
    try{
      fetch('/api/anzeigenmarkt/favorites/'+id+'/toggle', { method: 'POST', headers: { 'X-CSRF-Token': getCsrfToken() } })
        .then(function(r){
          if (r.status === 401) { window.location.href = '/anzeigenmarkt/users/login'; return Promise.reject(new Error('auth')); }
          return r.json();
        })
        .then(function(js){
          if(js && js.ok){
            // Update ALL favorite buttons for this listing ID on the page
            var allBtns = document.querySelectorAll('[data-id="'+id+'"]');
            allBtns.forEach(function(b){
              if(js.favorite){
                b.classList.add('active');
              } else {
                b.classList.remove('active');
              }
              // Update icon/text based on button type
              var icon = b.querySelector('i.fa');
              var span = b.querySelector('span');
              if(icon){
                // Header-style button with <i> + <span>
                icon.className = js.favorite ? 'fa fa-star' : 'fa fa-star-o';
                if(span) span.textContent = js.favorite ? 'Gespeichert' : 'Merken';
              } else if(b.classList.contains('am-fav-sidebar') || b.classList.contains('am-btn-action')){
                // Sidebar button with text + icon inline
                var iEl = b.querySelector('i');
                if(iEl){
                  iEl.className = js.favorite ? 'fa fa-star' : 'fa fa-star-o';
                }
                // Update text node (preserve the icon element)
                var textNodes = [];
                b.childNodes.forEach(function(n){ if(n.nodeType === 3 && n.textContent.trim()) textNodes.push(n); });
                if(textNodes.length > 0){
                  textNodes[textNodes.length - 1].textContent = js.favorite ? ' Gespeichert' : ' Merken';
                }
              } else {
                // Simple heart button (listing cards)
                b.textContent = '♥';
              }
            });
          }
        })
        .catch(function(err){
          if(err.message !== 'auth') console.error('Favorites toggle error:', err);
        });
    }catch(e){
      console.error('Favorites exception:', e);
    }
    return false;
  }
  window.AM.toggleFav = toggleFav;

  document.addEventListener('DOMContentLoaded', markActiveNav);
  document.addEventListener('DOMContentLoaded', function(){
    try {
      // Bind all favorite button variants: .am-fav, .am-fav-sidebar, .am-header-btn.am-fav
      document.querySelectorAll('.am-fav, .am-fav-sidebar').forEach(function(btn){
        btn.addEventListener('click', function(ev){ ev.preventDefault(); var id = btn.getAttribute('data-id'); if(id){ toggleFav(btn, id); } });
      });
    } catch(e) { /* no-op */ }
  });
  
  // Simple progressive enhancement: drag-and-drop zone for file uploads
  function initDropzones(){
    var forms = document.querySelectorAll('form.am-card[action*="/images/upload"]');
    forms.forEach(function(form){
      form.classList.add('am-dropzone');
      var input = form.querySelector('input[type="file"][multiple]');
      if(!input) return;
      ['dragenter','dragover','dragleave','drop'].forEach(function(evt){
        form.addEventListener(evt, function(e){ e.preventDefault(); e.stopPropagation(); }, false);
      });
      ['dragenter','dragover'].forEach(function(evt){ form.addEventListener(evt, function(){ form.classList.add('is-dragover'); }); });
      ;['dragleave','drop'].forEach(function(evt){ form.addEventListener(evt, function(){ form.classList.remove('is-dragover'); }); });
      form.addEventListener('drop', function(e){
        var dt = e.dataTransfer; if(!dt || !dt.files) return;
        input.files = dt.files; // assign dropped files to input
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initDropzones);

  function initPasswordToggles(){
    document.querySelectorAll('[data-am-password-toggle]').forEach(function(btn){
      var targetId = btn.getAttribute('data-am-password-toggle');
      var input = targetId ? document.getElementById(targetId) : null;
      if(!input) return;
      btn.addEventListener('click', function(){
        var showPassword = input.getAttribute('type') === 'password';
        input.setAttribute('type', showPassword ? 'text' : 'password');
        btn.setAttribute('aria-pressed', showPassword ? 'true' : 'false');
        btn.setAttribute('aria-label', showPassword ? 'Passwort verbergen' : 'Passwort anzeigen');
        var icon = btn.querySelector('i');
        if(icon) icon.className = showPassword ? 'fa fa-eye-slash' : 'fa fa-eye';
        input.focus();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initPasswordToggles);

  // Chat: send + poll helpers
  function sendMsg(event){
    try{
      event.preventDefault();
      var form = event.target;
      var btn = form.querySelector('button[type="submit"]');
      var originalText = btn ? btn.innerHTML : '';

      // Show loading state
      if(btn){ btn.innerHTML = '<i class="fa fa-spinner fa-spin"></i> Senden...'; btn.disabled = true; }

      // Remove old feedback
      var oldFeedback = form.querySelector('.am-msg-feedback');
      if(oldFeedback) oldFeedback.remove();

      var data = new FormData(form);
      fetch(form.action, { method: 'POST', body: data, headers: { 'X-CSRF-Token': getCsrfToken() } })
        .then(function(r){ return r.json().then(function(js){ return {status: r.status, data: js}; }); })
        .then(function(result){
          var feedback = document.createElement('div');
          feedback.className = 'am-msg-feedback';
          feedback.style.cssText = 'margin-top:10px; padding:10px; border-radius:6px;';

          if(result.data && result.data.ok){
            feedback.style.background = '#d1fae5';
            feedback.style.color = '#065f46';
            feedback.innerHTML = '<i class="fa fa-check"></i> Nachricht erfolgreich gesendet! <a href="/anzeigenmarkt/chat">Zum Chat</a>';
            form.querySelector('textarea').value = '';
            trackEvent('contact_sent', { source: 'chat_form' });
          } else if(result.status === 401){
            feedback.style.background = '#fef3c7';
            feedback.style.color = '#92400e';
            feedback.innerHTML = '<i class="fa fa-exclamation-triangle"></i> Bitte <a href="/anzeigenmarkt/users/login">anmelden</a> um Nachrichten zu senden.';
          } else {
            feedback.style.background = '#fee2e2';
            feedback.style.color = '#991b1b';
            // Security Fix: textContent statt innerHTML für User-Input (XSS Prevention)
            feedback.innerHTML = '<i class="fa fa-times"></i> Fehler beim Senden: ';
            var errorText = document.createElement('span');
            errorText.textContent = result.data.message || result.data.error || 'Unbekannt';
            feedback.appendChild(errorText);
          }
          form.appendChild(feedback);

          // Reset button
          if(btn){ btn.innerHTML = originalText; btn.disabled = false; }
        })
        .catch(function(err){
          if(btn){ btn.innerHTML = originalText; btn.disabled = false; }
          alert('Netzwerkfehler: ' + err.message);
        });
    }catch(e){ console.error(e); }
    return false;
  }
  window.AM = window.AM || {}; window.AM.sendMsg = sendMsg;

  // Report abuse
  function sendReport(event){
    try{
      event.preventDefault();
      var form = event.target;
      var data = new FormData(form);
      fetch(form.action, { method:'POST', body:data, headers: { 'X-CSRF-Token': getCsrfToken() } })
        .then(function(r){ return r.json(); })
        .then(function(js){
          var msg = document.getElementById('am-report-msg');
          if(js && js.ok){
            if(msg){ msg.style.display='block'; }
            trackEvent('report_submitted', { source: 'listing_report' }, parseInt((form.querySelector('[name="listing_id"]') || {}).value || '0', 10) || null, 'listing_detail');
          }
        });
    }catch(e){}
    return false;
  }
  window.AM.sendReport = sendReport;

  // Active filter chips (client-side)
  function renderActiveFilters(){
    try{
      var wrap = document.getElementById('am-active-filters');
      var cont = document.getElementById('am-chips');
      if(!wrap || !cont) return;
      var params = new URLSearchParams(window.location.search);
      var chips = [];
      params.forEach(function(value, key){
        if(!value || value === '') return;
        var label = null;
        if(key === 'vehicle_type') label = 'Fahrzeugtyp: ' + value;
        else if(key === 'body_type') label = 'Aufbau: ' + value;
        else if(key === 'euro_norm') label = 'Euro: ' + value;
        else if(key === 'fuel_type') label = 'Kraftstoff: ' + value;
        else if(key === 'gearbox') label = 'Getriebe: ' + value;
        else if(key === 'year_min') label = 'Jahr ≥ ' + value;
        else if(key === 'year_max') label = 'Jahr ≤ ' + value;
        else if(key === 'price_min') label = 'Preis ≥ ' + value;
        else if(key === 'price_max') label = 'Preis ≤ ' + value;
        else if(key === 'city') label = 'Stadt: ' + value;
        else if(key === 'zip') label = 'PLZ: ' + value;
        else if(key === 'vat_deductible') label = 'MwSt. ausweisbar';
        else if(key === 'verified') label = 'Verifiziert';
        else if(key.indexOf('attr[') === 0) {
          var inner = key.substring(5, key.length - 1); // inside []
          var map = {
            'achsformel':'Achsformel', 'federung':'Federung', 'fahrerhaus':'Fahrerhaus',
            'kran_hersteller':'Kran', 'kran_hubmoment[min]':'Hubmoment ≥', 'kran_hubmoment[max]':'Hubmoment ≤',
            'laderaum_hoehe':'Dachhöhe', 'tueren[]':'Hecktüren', 'schiebetuer':'Schiebetür',
            'radstand':'Radstand', 'sitzplaetze':'Sitzplätze',
            'ladung_volumen_m3[min]':'Volumen ≥', 'ladung_volumen_m3[max]':'Volumen ≤',
            'laderaum_laenge[min]':'Laderaumlänge ≥', 'laderaum_laenge[max]':'Laderaumlänge ≤',
            'anhaengelast[min]':'Anhängelast ≥', 'anhaengelast[max]':'Anhängelast ≤',
            'betriebsstunden[min]':'Bh ≥', 'betriebsstunden[max]':'Bh ≤',
            'betriebsgewicht[min]':'Gewicht ≥', 'betriebsgewicht[max]':'Gewicht ≤',
            'grabtiefe[min]':'Grabtiefe ≥', 'grabtiefe[max]':'Grabtiefe ≤',
            'hydraulik_kreis':'Hydraulik-Kreise', 'kabine':'Kabine', 'fahrwerk':'Fahrwerk',
            'klimaanlage':'Klimaanlage', 'rueckfahrkamera':'Rückfahrkamera', 'steuerung':'Steuerung', 'tuev':'TÜV'
          };
          label = (map[inner] || inner) + (value && value !== '1' ? (': ' + value) : '');
        }
        if(label){ chips.push({ key:key, label:label }); }
      });
      if(!chips.length){ wrap.style.display='none'; return; }
      wrap.style.display='block'; cont.innerHTML='';
      chips.forEach(function(ch){
        var el = document.createElement('span'); el.className='am-chip';
        // Security Fix: textContent statt innerHTML für URL-Parameter (XSS Prevention)
        var labelSpan = document.createElement('span');
        labelSpan.textContent = ch.label;
        el.appendChild(labelSpan);
        var btn = document.createElement('button'); btn.type='button'; btn.setAttribute('aria-label','Filter entfernen'); btn.textContent='×';
        btn.addEventListener('click', function(){
          var p = new URLSearchParams(window.location.search);
          if(ch.key.indexOf('attr[') === 0){ p.delete(ch.key); } else { p.delete(ch.key); }
          p.delete('page');
          window.location.search = p.toString();
        });
        el.appendChild(btn); cont.appendChild(el);
      });
    }catch(e){}
  }
  document.addEventListener('DOMContentLoaded', renderActiveFilters);

  // View mode toggle (list/map)
  function applyViewMode(mode){
    try{
      if(mode !== 'list' && mode !== 'map'){ mode = 'list'; }
      var split = document.getElementById('split-container'); if(!split) return;
      split.classList.remove('split-mode-list','split-mode-map','split-mode-split');
      if(mode==='map') split.classList.add('split-mode-map');
      else split.classList.add('split-mode-list');
      localStorage.setItem('am_view_mode', mode);
      var mapCont = document.getElementById('map-container');
      var mt = document.getElementById('map-toggle');
      if(mode==='map'){
        if(mapCont && (mapCont.style.display==='none' || getComputedStyle(mapCont).display==='none')){ if(mt){ mt.click(); } }
      } else if (mode==='list') {
        if(mapCont && !(mapCont.style.display==='none' || getComputedStyle(mapCont).display==='none')){ if(mt){ mt.click(); } }
      }

      // Highlight active button
      document.querySelectorAll('.view-toggle-btn').forEach(function(b){ b.classList.remove('is-active'); });
      var btn = document.querySelector('.view-toggle-btn[data-view="'+mode+'"]'); if(btn){ btn.classList.add('is-active'); }
    }catch(e){}
  }
  document.addEventListener('DOMContentLoaded', function(){
    try{
      var mode = localStorage.getItem('am_view_mode') || 'list';
      applyViewMode(mode);
      document.querySelectorAll('button[data-view]').forEach(function(btn){
        btn.addEventListener('click', function(){ applyViewMode(btn.getAttribute('data-view')); });
      });
    }catch(e){}
  });

  // Inject extra transporter filters (DOM-based, robust to template encodings)
  function injectTransporterExtras(){
    try{
      var detailsList = Array.prototype.slice.call(document.querySelectorAll('details.am-card'));
      var trans = detailsList.find(function(d){ var s=d.querySelector('summary'); return s && /Transporter/i.test(s.textContent||''); });
      if(!trans) return;
      var grid = trans.querySelector('div'); if(!grid) return;
      var params = new URLSearchParams(window.location.search);
      function addInput(name, placeholder, type){
        var el = document.createElement('input'); el.className='form-control'; el.name=name; el.placeholder=placeholder; el.type=type||'number';
        var v = params.get(name.replace(/\[/g,'%5B').replace(/\]/g,'%5D')); if(v!==null){ el.value=v; }
        grid.appendChild(el);
      }
      function addRange(prefix, minPH, maxPH){ addInput(prefix+'[min]', minPH, 'number'); addInput(prefix+'[max]', maxPH, 'number'); }
      function addSelect(name, opts){
        var sel = document.createElement('select'); sel.className='form-control'; sel.name=name; var cur = params.get(name) || '';
        var def = document.createElement('option'); def.value=''; def.textContent=opts._label||''; sel.appendChild(def);
        Object.keys(opts).forEach(function(k){ if(k===' _label' || k==='_label') return; var op=document.createElement('option'); op.value=k; op.textContent=opts[k]; if(cur===k){ op.selected=true; } sel.appendChild(op); });
        grid.appendChild(sel);
      }
      // Sitzplätze
      addInput('attr[sitzplaetze]','Sitzplaetze','number');
      // Radstand
      addSelect('attr[radstand]', {_label:'Radstand','kurz':'Kurz','mittel':'Mittel','lang':'Lang'});
      // Laderaumlaenge
      addRange('attr[laderaum_laenge]','Laderaumlaenge min (mm)','Laderaumlaenge max (mm)');
      // Anhaengelast
      addRange('attr[anhaengelast]','Anhaengelast min (kg)','Anhaengelast max (kg)');
    }catch(e){}
  }
  document.addEventListener('DOMContentLoaded', injectTransporterExtras);

  // Inject extra baumaschinen filters
  function injectBaumaschinenExtras(){
    try{
      var detailsList = Array.prototype.slice.call(document.querySelectorAll('details.am-card'));
      var bau = detailsList.find(function(d){ var s=d.querySelector('summary'); return s && /Baumaschinen/i.test(s.textContent||''); });
      if(!bau) return;
      var grid = bau.querySelector('div'); if(!grid) return;
      var params = new URLSearchParams(window.location.search);
      function addInput(name, placeholder, type){ var el=document.createElement('input'); el.className='form-control'; el.name=name; el.placeholder=placeholder; el.type=type||'text'; var v=params.get(name.replace(/\[/g,'%5B').replace(/\]/g,'%5D')); if(v!==null){ el.value=v; } grid.appendChild(el); }
      function addCheckbox(name, label){ var wrap=document.createElement('label'); wrap.style.display='flex'; wrap.style.alignItems='center'; wrap.style.gap='6px'; var el=document.createElement('input'); el.type='checkbox'; el.name=name; el.value='1'; if(params.get(name.replace(/\[/g,'%5B').replace(/\]/g,'%5D'))){ el.checked=true; } wrap.appendChild(el); wrap.appendChild(document.createTextNode(' '+label)); grid.appendChild(wrap); }
      function addSelect(name, label, opts){ var sel=document.createElement('select'); sel.className='form-control'; sel.name=name; var cur=params.get(name)||''; var def=document.createElement('option'); def.value=''; def.textContent=label; sel.appendChild(def); Object.keys(opts).forEach(function(k){ var op=document.createElement('option'); op.value=k; op.textContent=opts[k]; if(cur===k){ op.selected=true; } sel.appendChild(op); }); grid.appendChild(sel); }
      // Hydraulik-Kreise
      addInput('attr[hydraulik_kreis]','Hydraulik-Kreise','number');
      // Kabine
      addSelect('attr[kabine]','Kabine', {'offen':'Offen','geschlossen':'Geschlossen'});
      // Fahrwerk
      addSelect('attr[fahrwerk]','Fahrwerk', {'kette':'Kette','rad':'Rad'});
      // Klimaanlage / Rückfahrkamera / TÜV / Steuerung
      addCheckbox('attr[klimaanlage]','Klimaanlage');
      addCheckbox('attr[rueckfahrkamera]','Rückfahrkamera');
      addCheckbox('attr[tuev]','TÜV');
      addInput('attr[steuerung]','Maschinensteuerung');
    }catch(e){}
  }
  document.addEventListener('DOMContentLoaded', injectBaumaschinenExtras);
  // Save search
  function saveSearch(){
    try{
      var form = document.getElementById('am-search');
      if(!form) return false;
      var fd = new FormData(form);
      var data = {};
      fd.forEach(function(v,k){ data[k] = v; });
      var name = 'Suche';
      var body = new FormData();
      body.append('name', name);
      body.append('notify_email', '1');
      body.append('query_json', JSON.stringify(data));
      fetch('/api/anzeigenmarkt/saved-searches', { method:'POST', body: body, headers: { 'X-CSRF-Token': getCsrfToken() } })
        .then(function(r){ if(r.status===401){ window.location.href='/anzeigenmarkt/users/login'; return Promise.reject(new Error('auth')); } return r.json(); })
        .then(function(js){ if(js && js.ok){ var el=document.getElementById('am-save-msg'); if(el){ el.style.display='block'; el.textContent='Suche gespeichert.'; } trackEvent('saved_search_created', { saved_search_id: js.id || null }); } });
    }catch(e){}
    return false;
  }
  document.addEventListener('DOMContentLoaded', function(){
    var btn = document.getElementById('am-save-search'); if(btn){ btn.addEventListener('click', function(e){ e.preventDefault(); saveSearch(); }); }
  });

  // Load & render saved searches
  var _savedSearchClickOutsideBound = false;
  function renderSavedSearches(items){
    var wrapper = document.getElementById('am-saved-wrapper');
    var list = document.getElementById('am-saved-list');
    if(!wrapper || !list) return;
    if(!items || items.length === 0){ wrapper.style.display = 'none'; return; }
    wrapper.style.display = 'flex';
    list.innerHTML = '';
    items.forEach(function(it){
      var pill = document.createElement('div');
      pill.className = 'am-saved-pill';

      var link = document.createElement('a');
      link.href = buildSearchUrlFromSaved(it);
      link.textContent = it.name || 'Suche';
      link.title = (it.name || 'Suche') + (it.created_at ? ' – Erstellt am ' + it.created_at.substring(0,10) : '');
      link.addEventListener('click', function(){ trackEvent('saved_search_updated', { action: 'open', saved_search_id: it.id }); });

      var chevron = document.createElement('i');
      chevron.className = 'fa fa-chevron-down am-saved-chevron';
      chevron.addEventListener('click', function(e){
        e.stopPropagation();
        var dd = pill.querySelector('.am-saved-pill-dd');
        document.querySelectorAll('.am-saved-pill-dd.is-open').forEach(function(el){ if(el !== dd) el.classList.remove('is-open'); });
        dd.classList.toggle('is-open');
      });

      var dd = document.createElement('div');
      dd.className = 'am-saved-pill-dd';
      var freqLabel = document.createElement('label');
      freqLabel.textContent = 'Benachrichtigung';
      var frequency = document.createElement('select');
      var selectedFrequency = parseInt(it.notify_email) === 0 ? 'off' : (it.frequency || 'daily');
      ['daily', 'weekly', 'off'].forEach(function(opt){
        var option = document.createElement('option');
        option.value = opt;
        option.textContent = opt === 'daily' ? 'Täglich' : (opt === 'weekly' ? 'Wöchentlich' : 'Aus');
        if (selectedFrequency === opt) option.selected = true;
        frequency.appendChild(option);
      });
      frequency.addEventListener('change', function(){
        var isOff = this.value === 'off';
        updateSavedSearch(it.id, { frequency: isOff ? 'daily' : this.value, notify_email: isOff ? '0' : '1' });
      });
      var del = document.createElement('button');
      del.className = 'am-saved-delete-btn';
      del.textContent = 'Suche löschen';
      del.addEventListener('click', function(){ deleteSavedSearch(it.id); });

      dd.appendChild(freqLabel);
      dd.appendChild(frequency);
      dd.appendChild(del);
      pill.appendChild(link);
      pill.appendChild(chevron);
      pill.appendChild(dd);
      list.appendChild(pill);
    });

    if(!_savedSearchClickOutsideBound){
      _savedSearchClickOutsideBound = true;
      document.addEventListener('click', function(e){
        if(!e.target.closest('.am-saved-pill')){
          document.querySelectorAll('.am-saved-pill-dd.is-open').forEach(function(el){ el.classList.remove('is-open'); });
        }
      });
    }
  }

  function buildSearchUrlFromSaved(it){
    try{
      var q = JSON.parse(it.query_json || '{}');
      var params = new URLSearchParams();
      if(Array.isArray(q)) q = {};
      Object.keys(q || {}).forEach(function(k){ if(q[k]!=='' && q[k]!=null){ params.append(k, q[k]); } });
      if(!params.has('show')) params.set('show', 'all');
      return '/anzeigenmarkt?' + params.toString();
    }catch(e){ return '/anzeigenmarkt?show=all'; }
  }

  function loadSavedSearches(){
    fetch('/api/anzeigenmarkt/saved-searches')
      .then(function(r){ if(r.status===401){ return {items:[]} } return r.json(); })
      .then(function(js){ if(js && js.items){ renderSavedSearches(js.items); } });
  }
  function updateSavedSearch(id, payload){
    var body = new FormData();
    Object.keys(payload || {}).forEach(function(k){ body.append(k, payload[k]); });
    fetch('/api/anzeigenmarkt/saved-searches/'+id, { method:'POST', body: body, headers: { 'X-CSRF-Token': getCsrfToken() } })
      .then(function(r){ if(r.status===401){ window.location.href='/anzeigenmarkt/users/login'; return null; } return r.json(); })
      .then(function(js){ if(js && js.ok){ trackEvent('saved_search_updated', { saved_search_id: id }); } });
  }
  function deleteSavedSearch(id){
    fetch('/api/anzeigenmarkt/saved-searches/'+id+'/delete', { method:'POST', headers: { 'X-CSRF-Token': getCsrfToken() } })
      .then(function(r){ if(r.status===401){ window.location.href='/anzeigenmarkt/users/login'; return; } return r.json ? r.json() : null; })
      .then(function(){ trackEvent('saved_search_deleted', { saved_search_id: id }); loadSavedSearches(); });
  }
  document.addEventListener('DOMContentLoaded', loadSavedSearches);
  window.loadSavedSearches = loadSavedSearches;

  // Dynamic subcategory loading
  function initSubcategoryLoader() {
    var categorySelect = document.getElementById('am-category-select');
    var subcategorySelect = document.getElementById('am-subcategory-select');
    var subcategoryWrapper = document.getElementById('am-subcategory-wrapper');

    if (!categorySelect || !subcategorySelect) return;

    categorySelect.addEventListener('change', function() {
      var categorySlug = categorySelect.value;

      // Clear current subcategory options
      subcategorySelect.innerHTML = '<option value="">Alle Unterkategorien</option>';

      if (!categorySlug) {
        // Disable subcategory visually if no category selected
        if (subcategoryWrapper) subcategoryWrapper.classList.add('am-category-disabled');
        return;
      }

      // Fetch subcategories from API
      fetch('/api/anzeigenmarkt/subcategories?category=' + encodeURIComponent(categorySlug))
        .then(function(response) {
          if (!response.ok) throw new Error('Failed to load subcategories');
          return response.json();
        })
        .then(function(data) {
          var subcategories = data.subcategories || [];

          if (subcategories.length > 0) {
            // Enable subcategory dropdown
            if (subcategoryWrapper) subcategoryWrapper.classList.remove('am-category-disabled');

            // Add subcategory options
            subcategories.forEach(function(sub) {
              var option = document.createElement('option');
              option.value = sub.slug;
              option.textContent = sub.name;
              subcategorySelect.appendChild(option);
            });
          } else {
            // Disable subcategory if no subcategories
            if (subcategoryWrapper) subcategoryWrapper.classList.add('am-category-disabled');
          }
        })
        .catch(function(error) {
          console.error('Error loading subcategories:', error);
          if (subcategoryWrapper) subcategoryWrapper.classList.add('am-category-disabled');
        });
    });
  }

  document.addEventListener('DOMContentLoaded', initSubcategoryLoader);

  function trackEvent(eventName, meta, listingId, pageType){
    try {
      var payload = {
        event_name: eventName,
        page_type: pageType || (document.body.classList.contains('anzeigenmarkt-mobile') ? 'anzeigenmarkt_mobile' : 'anzeigenmarkt'),
        listing_id: listingId || null,
        meta: meta || {}
      };
      fetch('/api/anzeigenmarkt/events', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': getCsrfToken() },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
      });
    } catch (e) {}
  }

  window.AM = window.AM || {};
  window.AM.trackEvent = trackEvent;

  document.addEventListener('DOMContentLoaded', function(){
    trackEvent('page_view', { path: window.location.pathname + window.location.search });

    var searchForm = document.getElementById('am-search');
    if (searchForm) {
      searchForm.addEventListener('submit', function(){
        var searchInput = searchForm.querySelector('input[name="q"]');
        var categoryInput = searchForm.querySelector('[name="category"]');
        trackEvent('search_performed', { q: searchInput ? searchInput.value : '', category: categoryInput ? categoryInput.value : '' });
      });
    }

    var listingElement = document.querySelector('[data-listing-id]');
    if (listingElement) {
      trackEvent('listing_view', {}, parseInt(listingElement.getAttribute('data-listing-id') || '0', 10) || null, 'listing_detail');
    }

    document.querySelectorAll('[data-am-track="similar_clicked"]').forEach(function(link){
      link.addEventListener('click', function(){
        var id = parseInt(this.getAttribute('data-listing-id') || '0', 10) || null;
        trackEvent('similar_clicked', { source: 'listing_detail' }, id, 'listing_detail');
      });
    });
  });
})();
